import { createContext } from 'react';

/**
 * True inside a settings section whose page already shows the "Saves
 * automatically" caption under the section title (an instant-save section):
 * the panels inside then leave out their own, so the caption appears once,
 * in the same place, on every page.
 */
export const InstantCaptionShownContext = createContext(false);
